module.exports = function() {
  return new Worker(__webpack_public_path__ + "60325bdda8f5d92f8968.worker.js");
};